import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { useAuth } from 'utils/hooks/useAuth';
import { useProviderSpecificConfiguration } from 'modules/appConfiguration/useProviderSpecificConfiguration';
import analytics from 'functions/analytics';
import darkLogoSrc from 'assets/full_leal_logo_dark.svg';
import LanguageMenu from 'new-ui/Components/LanguageMenu';
import { LoginButton } from 'components/LoginButton/LoginButton';
import { SaveProfileButton } from './SaveProfileButton';
import styles from './questionnairePageHeaderView.module.css';

export const QuestionnairePageHeaderView = () => {
  const { isAuthenticated, isAuthPending } = useAuth();
  const { code: providerCode, headerBackgroundColor } = useProviderSpecificConfiguration();
  const currentQuestionIndex = useSelector((state) => state.questionnaire.currentIndex);

  const [isSaveButtonShown, setIsSaveButtonShown] = useState();

  const shouldStartTimer = currentQuestionIndex > 1;

  useEffect(() => {
    let timer = null;
    if (shouldStartTimer) {
      if (isAuthenticated) {
        setIsSaveButtonShown(true);
      } else {
        timer = setTimeout(() => {
          setIsSaveButtonShown(true);
        }, 2000);
      }
    }

    return () => {
      clearInterval(timer);
    };
  }, [isAuthenticated, shouldStartTimer]);

  useEffect(() => {
    if (isSaveButtonShown && !isAuthenticated) {
      analytics.quickSignUpBtnViewed();
    }
  }, [isAuthenticated, isSaveButtonShown]);

  return (
    <header
      className={cx(styles.root, providerCode ? styles.providerRoot : styles.nonProviderRoot)}
      style={{ backgroundColor: headerBackgroundColor }}
    >
      {!providerCode && (
        <img
          className={styles.logo}
          src={darkLogoSrc}
          alt="Leal Health Logo"
        />
      )}

      <div className={styles.rightGroup}>
        {isSaveButtonShown && (
          <SaveProfileButton isLoggedUser={isAuthenticated} />
        )}
        {!isAuthenticated && !isAuthPending && <LanguageMenu />}
        {!isSaveButtonShown && !isAuthenticated && !isAuthPending && <LoginButton />}
      </div>
    </header>
  );
};
